import { useQuery } from "@apollo/client";
import slackLogo from "@static/img/slack.png";
import {
  GetOrganizationNotificationsQuery,
  GetOrganizationNotificationsQueryVariables,
  OrgSettingsOrganizationFragmentFragment,
} from "types/graphql-schema";

import SlackNotification from "@apps/org-settings/components/slack-notification";
import {
  assertEdgesNonNull,
  assertEdgesNonNullWithStringId,
  getAssetUrl,
} from "@helpers/helpers";

import getOrganizationNotifications from "../graphql/get-organization-notifications";

const Notifications = ({
  organization,
}: {
  organization: OrgSettingsOrganizationFragmentFragment;
}) => {
  const { data } = useQuery<
    GetOrganizationNotificationsQuery,
    GetOrganizationNotificationsQueryVariables
  >(getOrganizationNotifications, {
    variables: {
      organizationId: organization.id,
    },
  });
  const slackNotifications = data?.organization?.slackNotifications
    ? assertEdgesNonNull(data.organization.slackNotifications)
    : [];
  const channels = data?.organization?.publicSlackChannels
    ? assertEdgesNonNullWithStringId(data.organization.publicSlackChannels)
    : [];
  const channelOptions = channels.map((channel) => ({
    label: `#${channel.name}`,
    value: channel.id,
    ...channel,
  }));
  const existingChannelIds = slackNotifications.map(({ channel }) => channel);

  return (
    <div>
      <h2 className="text-2xl pb-2 font-medium text-gray-800">Notifications</h2>
      <ul className="bg-white py-4 flex" aria-label="Notification list">
        <div className="col font-medium mb-4 flex items-start w-28 shrink-0">
          <div className="border rounded flex justify-center items-center h-24 w-28 p-4">
            <img
              src={getAssetUrl(slackLogo)}
              alt="slack"
              className="object-contain h-16"
            />
          </div>
        </div>
        <div className="flex flex-col divide-y divide-gray-100 pl-5">
          <div>
            Send notifcations of recognitions or goal check-ins to one or more
            Slack channels
          </div>
          {slackNotifications.map((slackNotification) => (
            <SlackNotification
              key={slackNotification.id}
              channels={channelOptions}
              slackNotification={slackNotification}
              organization={organization}
              existingChannelIds={existingChannelIds}
            />
          ))}
          <SlackNotification
            channels={channelOptions}
            slackNotification={null}
            organization={organization}
            existingChannelIds={existingChannelIds}
          />
        </div>
      </ul>
    </div>
  );
};

export default Notifications;
